import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-additional-offer-info',
  templateUrl: './additional-offer-info.component.html',
  styleUrls: ['./additional-offer-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdditionalOfferInfoComponent { }
